module.exports = __webpack_public_path__ + "img/feature-1.411b7a4f.png";